module.exports = __webpack_public_path__ + "media/iconic/share-2b43d379.svg";